import React from 'react';
import { Mail, Save, Send } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';

const SmtpTab = ({ smtpSettings, onSmtpChange, onSave, saving, testEmail, setTestEmail, onTest, testing }) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Mail className="h-5 w-5" /> SMTP Configuration
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1">SMTP Host</label>
          <Input name="host" value={smtpSettings.host} onChange={onSmtpChange} placeholder="smtp.gmail.com" data-testid="smtp-host" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Port</label>
          <Input name="port" type="number" value={smtpSettings.port} onChange={onSmtpChange} placeholder="587" data-testid="smtp-port" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Username/Email</label>
          <Input name="username" value={smtpSettings.username} onChange={onSmtpChange} placeholder="your-email@gmail.com" data-testid="smtp-username" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Password/App Password</label>
          <Input name="password" type="password" value={smtpSettings.password} onChange={onSmtpChange} placeholder="••••••••" data-testid="smtp-password" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">From Email</label>
          <Input name="from_email" value={smtpSettings.from_email} onChange={onSmtpChange} placeholder="noreply@dayefarm.com" data-testid="smtp-from-email" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">From Name</label>
          <Input name="from_name" value={smtpSettings.from_name} onChange={onSmtpChange} placeholder="Daye Farm Ltd" data-testid="smtp-from-name" />
        </div>
      </div>

      <div className="flex gap-4">
        <label className="flex items-center gap-2">
          <input type="checkbox" name="use_tls" checked={smtpSettings.use_tls} onChange={onSmtpChange} className="rounded" />
          <span className="text-sm">Use TLS</span>
        </label>
        <label className="flex items-center gap-2">
          <input type="checkbox" name="use_ssl" checked={smtpSettings.use_ssl} onChange={onSmtpChange} className="rounded" />
          <span className="text-sm">Use SSL</span>
        </label>
      </div>

      <div className="flex gap-2">
        <Button onClick={onSave} disabled={saving}>
          <Save className="h-4 w-4 mr-2" /> {saving ? 'Saving...' : 'Save SMTP Settings'}
        </Button>
      </div>

      <div className="border-t pt-6 mt-6">
        <h3 className="font-semibold mb-3">Test SMTP Configuration</h3>
        <div className="flex gap-2">
          <Input value={testEmail} onChange={(e) => setTestEmail(e.target.value)} placeholder="Enter email to send test" className="max-w-xs" data-testid="test-email-input" />
          <Button onClick={onTest} disabled={testing} variant="outline">
            <Send className="h-4 w-4 mr-2" /> {testing ? 'Sending...' : 'Send Test Email'}
          </Button>
        </div>
        <p className="text-sm text-gray-500 mt-2">Save your settings first, then send a test email to verify the configuration.</p>
      </div>
    </CardContent>
  </Card>
);

export default SmtpTab;
